export const NUM_OF_JWT_PARTS = 3;
export const JWT_PATTERN = /^[A-Za-z0-9_-]+$/; // base64url encoding without padding